// Pure calculation functions — no React, no DOM, fully portable to React Native

export const calcFL = (c, gpm, ft) => c * Math.pow(gpm / 100, 2) * (ft / 100);
export const calcElev = (ft) => 0.5 * ft; // 0.5 psi/ft (EP = 0.5H)
export const calcGPM = (d, np) => 29.7 * d * d * Math.sqrt(np); // Freeman smoothbore GPM constant
export const calcNRsb = (d, np) => 1.57 * d * d * np;           // smoothbore nozzle reaction constant
export const calcNRfg = (g, np) => 0.0505 * g * Math.sqrt(np);  // fog/combo nozzle reaction constant
export const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

let _uid = 0;
export const uid = () => ++_uid;

// Firestore-safe unique ID (for log entries, checklist items, etc.)
export const fsId = () => Date.now().toString(36) + Math.random().toString(36).slice(2);

// Format elapsed time in mm:ss or h:mm:ss
export const fmtElapsed = (ms) => {
  const s = Math.floor(ms / 1000);
  const m = Math.floor(s / 60);
  const h = Math.floor(m / 60);
  return h > 0
    ? `${h}:${String(m % 60).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`
    : `${String(m).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
};

// Format a Timestamp offset from dispatch as +mm:ss or +h:mm:ss
export const fmtOffset = (entryTime, dispatchTime) => {
  if (!entryTime || !dispatchTime) return '+00:00';
  const ms = (entryTime.toMillis ? entryTime.toMillis() : entryTime) - (dispatchTime.toMillis ? dispatchTime.toMillis() : dispatchTime);
  const s = Math.floor(ms / 1000);
  const m = Math.floor(s / 60);
  const h = Math.floor(m / 60);
  return h > 0
    ? `+${h}:${String(m % 60).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`
    : `+${String(m).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
};
